"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoOptionsMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var NoOptionsMessage = exports.NoOptionsMessage = function NoOptionsMessage(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactSelect.components.NoOptionsMessage, props));
};